<template>
  <div>
    <a-page-header>
      <template v-slot:title>
        <a-space align="center">
          <div
            class="ant-descriptions-title"
            style="font-size: 20px; margin-bottom: 0px"
          >
            权证管理
          </div>
        </a-space>
      </template>
      <!-- actions -->
      <template v-slot:extra>
        <!-- 固钉 -->
        <a-affix :offset-top="10">
          <a-button-group style="margin-right: 2px">
            <!-- 编辑 -->
            <template v-if="toDetailData.auditStatus == 1">
              <a-button @click="back">返回</a-button>
              <a-button @click="onSave">保存</a-button>
              <a-button type="primary" @click="onSubmit">提交</a-button>
            </template>
            <!-- 审批通过 -->
            <template v-else-if="toDetailData.auditStatus == 3 && toDetailData.isEditable">
              <a-button @click="back">返回</a-button>
              <a-button type="primary" @click="onSubmit">提交</a-button>
            </template>
            <!-- 审批中/其他 -->
            <a-button v-else @click="back" type="primary">返回</a-button>
          </a-button-group>
        </a-affix>
      </template>

      <RightInfo
        :isEditable="toDetailData.isEditable"
        :webId="toDetailData.webId"
        ref="rightInfoRef"
        @back="back()"
      ></RightInfo>

      <!-- 回到最高点 -->
      <a-back-top style="margin-right: -100px" />
    </a-page-header>
  </div>
</template>

<script>
import RightInfo from "./rightsInfo/RightInfo";
import { scrollToTop } from "@/utils/util";
export default {
  props: {
    toDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    RightInfo,
  },

  data() {
    return {};
  },

  methods: {
    back() {
      this.$emit("changeToLeader");
      scrollToTop(this);
    },
    onSave() {
      // 保存（不提交）
      this.$refs.rightInfoRef.handleSave();
    },
    onSubmit() {
      // 提交（校验 + 提交）
      this.$refs.rightInfoRef.handleSubmit();
    },
  },
};
</script>

<style lang="less" scoped>
</style>